import { Component, inject, input, OnInit } from '@angular/core';
import {
  NzShowUploadList,
  NzUploadComponent,
  NzUploadFile,
  NzUploadListType,
  NzUploadXHRArgs,
} from 'ng-zorro-antd/upload';
import { Subscription, Observable, of, from, map } from 'rxjs';
import { FileManagerService } from './file-manager.service';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { NzIconDirective } from 'ng-zorro-antd/icon';
import { NzInputDirective } from 'ng-zorro-antd/input';
import { NzAutocompleteComponent, NzAutocompleteTriggerDirective } from 'ng-zorro-antd/auto-complete';
import { NzListComponent, NzListItemComponent } from 'ng-zorro-antd/list';
import { NzModalComponent, NzModalContentDirective } from 'ng-zorro-antd/modal';
import { NgTemplateOutlet } from '@angular/common';
import { FileManagerPreviewComponent } from './file-manager-preview.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { getDownloadURL, Storage, uploadBytesResumable, ref, deleteObject } from '@angular/fire/storage';

@Component({
  selector: 'ava-file-manager-upload',
  standalone: true,
  template: `
    <div style="margin: 5px 0">
      <nz-upload
        [nzCustomRequest]="handleUpload"
        [nzListType]="listType"
        [(nzFileList)]="uploadFileList"
        [nzRemove]="handleRemove"
        [nzShowUploadList]="showUploadList"
        [nzShowButton]="showUploadButton"
        [nzPreview]="handlePreview"
      >
        @if (listType !== 'picture-card') {
          <button nz-button nzType="primary" (click)="$event.preventDefault()">
            <i nz-icon nzType="upload"></i>
            Upload
          </button>
        }

        @if (listType === 'picture-card') {
          <div>
            <i nz-icon nzType="plus"></i>
            <div style="margin-top: 8px">Upload</div>
          </div>
        }
      </nz-upload>
    </div>

    <div [style]="'margin: 5px 0'">
      <input
        placeholder="search image list"
        nz-input
        [(ngModel)]="inputValue"
        (ngModelChange)="onChange($event)"
        [nzAutocomplete]="auto"
      />
      <nz-autocomplete [nzDataSource]="filteredOptions" #auto></nz-autocomplete>
    </div>

    <div [style]="'margin: 5px 0'">
      <button
        nz-button
        [nzType]="showList ? 'default' : 'primary'"
        (click)="showList = !showList; $event.preventDefault()"
        style="margin-right: 10px"
      >
        Show Image List
      </button>
      <button
        nz-button
        [nzType]="showInstructions ? 'default' : 'primary'"
        (click)="showInstructions = !showInstructions; $event.preventDefault()"
        style="margin-right: 10px"
      >
        Show Instructions
      </button>
    </div>

    @if (showList) {
      <div style="margin: 5px 0">
        <nz-list nzBordered nzSize="small">
          @for (file of fileList(); track file; let index = $index) {
            <nz-list-item (click)="handlePreview(file)">
              <!--            @if (g.adminUser) {-->
              <!--              <ul nz-list-item-actions>-->
              <!--                <nz-list-item-action>-->
              <!--                  <i-->
              <!--                    nz-icon-->
              <!--                    nzType="delete"-->
              <!--                    nzTheme="outline"-->
              <!--                    style="cursor: pointer"-->
              <!--                    (click)="fileDelete($event, file, index)"-->
              <!--                  ></i>-->
              <!--                </nz-list-item-action>-->
              <!--              </ul>-->
              <!--            }-->

              <div style="display: flex">
                <i nz-icon nzType="paper-clip" nzTheme="outline"></i>
                <div style="padding: 0 8px">
                  {{ file.name }}
                </div>
              </div>
            </nz-list-item>
          }
        </nz-list>
      </div>
    }

    <nz-modal
      [(nzVisible)]="showFilePreview"
      (nzOnCancel)="handleFilePreview()"
      (nzOnOk)="handleFilePreview()"
      [nzFooter]="null"
      nzWidth="90%"
    >
      <ava-file-manager-preview *nzModalContent [file]="fileManagerPreviewFile" />
    </nz-modal>

    <nz-modal
      [(nzVisible)]="showInstructions"
      (nzOnCancel)="handleInstructions()"
      (nzOnOk)="handleInstructions()"
      [nzFooter]="null"
      [nzBodyStyle]="{ padding: '30px' }"
    >
      <div *nzModalContent>
        <div>To add an image to this page you can either upload a new file or use an existing file.</div>
        <div style="margin: 10px">There are 3 ways to select an image.</div>

        <div style="font-weight: 900; margin: 10px">Upload a New Image</div>
        <ol>
          <li>Click on the [Upload] button and choose a file from your computer to upload.</li>
          <li>Your file will appear below the [Upload] button if the upload was successful.</li>
          <li>Select your file to open a preview popup</li>
          <ng-container *ngTemplateOutlet="instructions"></ng-container>
        </ol>

        <div style="font-weight: 900; margin: 10px">Find an Existing Image with the Search</div>
        <ol>
          <li>Under the [Upload] button is a search field for existing files. Type the name of image.</li>
          <li>Choose an image from the search results to open a preview popup.</li>
          <ng-container *ngTemplateOutlet="instructions"></ng-container>
        </ol>

        <div style="font-weight: 900; margin: 10px">Find an Existing Image from the Image List</div>
        <ol>
          <li>Under the search field is a button for Show Image List. Click the button.</li>
          <li>Choose an image from the Image List to open a preview popup.</li>
          <ng-container *ngTemplateOutlet="instructions"></ng-container>
        </ol>
      </div>
    </nz-modal>

    <ng-template #instructions>
      <li>Copy the full url of the image starting with https://www.wssfiles.com/</li>
      <li>
        Paste the full url strand into the Image field below [Show Image List] button (and the Image List if open).
      </li>
    </ng-template>
  `,
  imports: [
    ReactiveFormsModule,
    FormsModule,
    NzUploadComponent,
    NzButtonComponent,
    NzIconDirective,
    NzInputDirective,
    NzAutocompleteComponent,
    NzListComponent,
    NzListItemComponent,
    NzModalComponent,
    NzModalContentDirective,
    NgTemplateOutlet,
    FileManagerPreviewComponent,
    NzAutocompleteTriggerDirective,
  ],
})
export class FileManagerUploadComponent implements OnInit {
  private storage = inject(Storage);
  fmService = inject(FileManagerService);

  directory = input('');
  fileList = input<NzUploadFile[]>([]);

  uploadFileList: NzUploadFile[] = [];
  showList = false;
  showUploadList: boolean | NzShowUploadList = { showRemoveIcon: true, showDownloadIcon: false, showPreviewIcon: true };
  showUploadButton = true;
  // ref: AngularFireStorageReference | undefined;
  // task: AngularFireUploadTask | undefined;

  uploadProgress: { percent: number } = { percent: 0 };
  downloadURL = '';
  uploadState = false;

  listType: NzUploadListType = 'text';

  showInstructions = false;

  showFilePreview = false;
  fileManagerPreviewFile: NzUploadFile | undefined = undefined;

  inputValue?: string;
  options: string[] = [];
  filteredOptions: string[] = [];

  ngOnInit(): void {
    this.fileList().forEach((file) => this.options.push(file.name));
  }
  handleUpload = (item: NzUploadXHRArgs): Subscription => {
    const filePath = `${this.directory()}/${item.file.name}`;
    const storageRef = ref(this.storage, filePath);

    // @ts-ignore
    const file: File = item.file;

    const task = uploadBytesResumable(storageRef, file, {
      cacheControl: 'public, max-age=31104000',
    });

    task.on(
      'state_changed',
      (snapshot) => {
        const percent = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

        if (typeof item.onProgress === 'function') {
          this.uploadProgress.percent = percent;
          item.onProgress(this.uploadProgress, item.file);
        }
      },
      (error) => {
        if (typeof item.onError === 'function') {
          item.onError(error, item.file);
        }
      },
      async () => {
        const downloadURL = await getDownloadURL(task.snapshot.ref);

        if (typeof item.onSuccess === 'function') {
          item.onSuccess(downloadURL, item.file, task.snapshot);
        }

        this.uploadFileList[this.uploadFileList.length - 1].url = downloadURL;
      },
    );

    return new Subscription(() => task.cancel());
  };
  // Todo: need to test
  // handleUpload: (item: NzUploadXHRArgs) => Subscription = (item) => {
  //   this.task = this.afStorage.upload(this.directory + '/' + item.file.name, item.file, {
  //     cacheControl: 'public, max-age=31104000',
  //   });
  //
  //   this.task.percentageChanges().subscribe((percent) => {
  //     if (percent !== undefined && typeof item.onProgress === 'function') {
  //       this.uploadProgress.percent = percent;
  //       item.onProgress(this.uploadProgress, item.file);
  //     }
  //   });
  //
  //   return this.task.snapshotChanges().subscribe((snap) => {
  //     if (snap) {
  //       if (snap.state === 'success' && typeof item.onSuccess === 'function') {
  //         item.onSuccess('', item.file, '');
  //         this.uploadFileList[this.uploadFileList.length - 1].url =
  //           this.fmService.domain + '/' + this.directory + '/' + item.file.name;
  //       }
  //     }
  //   });
  // };

  // handleRemove: (file: NzUploadFile) => boolean | Observable<boolean> = (file) => {
  //   if (file.url) {
  //     this.afStorage.refFromURL(file.url).delete();
  //     return true;
  //   }
  //   return false;
  // };
  // Todo: need to test
  handleRemove: (file: NzUploadFile) => boolean | Observable<boolean> = (file) => {
    if (!file.url) {
      return false;
    }

    try {
      const storageRef = ref(this.storage, file.url);

      const delete$ = from(deleteObject(storageRef));

      return delete$.pipe(
        // convert success -> true
        // you could also tap() for logging if needed
        map(() => true),
      );
    } catch (err) {
      return of(false);
    }
  };

  // fileDelete(event: Event, file: NzUploadFile, index: number): void {
  //   if (confirm('please confirm to delete') && file.url) {
  //     this.afStorage.refFromURL(file.url).delete();
  //     this.fileList.splice(index, 1);
  //   }
  //   event.preventDefault();
  //   event.stopPropagation();
  // }

  handlePreview: (file: NzUploadFile) => void = (file) => {
    this.fileManagerPreviewFile = file;
    this.showFilePreview = true;
  };

  handleInstructions(): void {
    this.showInstructions = false;
  }

  handleFilePreview(): void {
    this.showFilePreview = false;
    this.fileManagerPreviewFile = undefined;
  }

  onChange(value: string): void {
    this.filteredOptions = this.options.filter((option) => option.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    if (this.fileList().find((file) => file.name === value)) {
      this.fileManagerPreviewFile = this.fileList().find((file) => file.name === value);
      this.showFilePreview = true;
    }
  }
}
